import { render, staticRenderFns } from "./listado_de_informacion_ingresada_por_supervisora.vue?vue&type=template&id=41c4f8e2"
import script from "./listado_de_informacion_ingresada_por_supervisora.vue?vue&type=script&lang=js"
export * from "./listado_de_informacion_ingresada_por_supervisora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports